import React, { useState, useEffect } from 'react'

//* Styles
import styles from './LanguageSwitcher.module.scss';

const FLAGS = {
    "it": "https://filotrack.com/wp-content/uploads/it.webp",
    "en": "https://filotrack.com/wp-content/uploads/en.webp",
    "de": "https://filotrack.com/wp-content/uploads/de.webp",
    "es": "https://filotrack.com/wp-content/uploads/es.webp",
    "fr": "https://filotrack.com/wp-content/uploads/fr.webp",
}

const MAIN_DOMAIN = "https://filotrack.com"

const LanguageSwitcher = () => {


    const [ { actualLanguage }, setActualLanguage ] = useState({ actualLanguage: document.documentElement.lang.substring(0, 2).toLowerCase() })

    useEffect(() => {
      
        const new_lang = document.documentElement.lang.substring(0,2).toLowerCase()
        setActualLanguage({ actualLanguage: new_lang })

    }, [])

    function changeLanguage(lang){

        if(lang !== actualLanguage ){
    
            let lastSlash = window.location.pathname.charAt(window.location.pathname.length - 1)
            let lastSlashIndex = lastSlash === "/" ? window.location.pathname.slice(0, -1).lastIndexOf("/") : window.location.pathname.lastIndexOf("/")
            let only_path_name = window.location.pathname.substring(lastSlashIndex + 1)
    
            let new_path = `${MAIN_DOMAIN}${lang === "en" ? "" : `/${lang}`}/${only_path_name}`
            console.log(new_path)
            setActualLanguage({ actualLanguage: lang })
    
            window.location.href = new_path
        }

    }
    

  return (
    <div className={styles["switcher-container"]}>
        <div className={styles["flags-container"]}>
            {
                Object.entries(FLAGS).map(([ lang, flagImg]) => {
                    return(
                        <div className={styles["flag"]}
                            key={`flag-${lang}`}
                            style={{
                                order: actualLanguage === lang ? "1" : "2"
                            }}
                            onClick={() => changeLanguage(lang)}
                        >
                            <img src={flagImg} alt={`${lang}-flag`} />
                        </div>
                    )
                })
            }
        </div>
    </div>
  )
}

export default LanguageSwitcher